export default __webpack_public_path__ + "static/pragicts-digital-outreach-banner-track-from-your-phone-4b1942ec358715191b8ba10fabcff674.jpg";